import { pumaAPI } from "./api"
import { ReceiveNothing } from "./api/base"

export const getBookmarks = (
    workspaceId: number | null,
    filter?: string,
): Promise<Api.PumaParsedPaginatedResponse<Models.Bookmark>> =>
    pumaAPI
        .getJSON("Bookmarks", { filter, workspaceId })
        .then((bookmarks: Api.PumaPaginatedResponse<Api.BookmarkDTO>) => ({
            paging: {
                pageSize: bookmarks.Paging.PageSize,
                totalRecordCount: bookmarks.Paging.TotalRecordCount,
            },
            data: bookmarks.Data.$values.map((bookmark: Api.BookmarkDTO) => ({
                bookmarkId: bookmark.BookmarkId,
                bookmarkUrl: bookmark.BookmarkUrl,
                personId: bookmark.PersonId,
                resourceId: bookmark.ResourceId,
                resourceType: bookmark.ResourceType,
                sequenceNr: bookmark.SequenceNr,
                title: bookmark.Title,
                workspaceId: bookmark.WorkspaceId,
                workspaceScreenLabel: bookmark.WorkspaceScreenLabel,
                icon: bookmark.Icon,
            })),
        }))

export const addBookmark = (
    resourceType: string,
    resourceId: number,
    resourceUrl: string,
    workspaceId: number | null,
    parentItemId?: number | null,
): Promise<number> =>
    pumaAPI
        .postJSON(`Bookmarks/${resourceType}`, {
            ResourceId: resourceId,
            ResourceUrl: resourceUrl,
            ParentId: parentItemId,
            WorkspaceId: workspaceId,
        })
        .then((bookmark: Api.BookmarkDTO) => bookmark.BookmarkId)

export const findBookmark = (
    resourceType: string,
    resourceId: number,
    parentItemId?: number | null,
): Promise<number | void> =>
    pumaAPI
        .postJSON(`Bookmarks/${resourceType}/FindBookmark`, {
            ResourceId: resourceId,
            ParentId: parentItemId,
        })
        .then((bookmark: Api.BookmarkDTO) => bookmark.BookmarkId)

export const removeBookmark = (bookmarkId: number): Promise<void> =>
    pumaAPI.remove(`Bookmarks/${bookmarkId}`)

export const saveBookmarkTitle = (
    bookmarkId: number,
    title: string,
): Promise<void> =>
    pumaAPI.putJSON(`Bookmarks/${bookmarkId}/title`, { title }, ReceiveNothing)
